/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { AxiosResponse } from 'axios';
// config
import http from '../instance';

export const api = {
  get: async (role: string, id: string): Promise<AxiosResponse> => {
    const api = await http();
    return api.get(`${role}/customer/${id}/assessments`);
  },

  getByID: async (role: string, id: string): Promise<AxiosResponse> => {
    const api = await http();
    return api.get(`${role}/customer/assessment/${id}/details`);
  },
};
